{
  "attachAria": "Attach file",
  "emptyHint": "Describe the issue — support will reply here",
  "emptyTitle": "No messages yet",
  "fileOpenAria": "Open attachment",
  "logAria": "Report conversation",
  "newMessages": "New messages",
  "placeholder": "Write a message…",
  "placeholderDisabled": "Messages are temporarily unavailable",
  "previewAria": "View attachment",
  "previewCloseAria": "Close preview",
  "removeAttachmentAria": "Remove file",
  "retry": "Retry",
  "screenshotAria": "Take a screenshot",
  "seen": "Seen",
  "sendAria": "Send message",
  "sendFailed": "Failed to send the message",
  "sending": "Sending…",
  "student": "Student",
  "supportName": "Skyeng Support",
  "today": "Today",
  "yesterday": "Yesterday",
  "you": "You"
}
